import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollManager = () => {
    const location = useLocation();
    const navigationType = useNavigationType();

    useLayoutEffect(() => {
        // ONLY reset scroll when changing routes normally
        // BUT NOT when returning BACK to a page that already existed in history

        if (navigationType === 'POP') {
            return;
        }

        if (window.history.state && window.history.state.idx === 0) {
            // first load
            window.scrollTo(0, 0);
            return;
        }

        window.scrollTo(0, 0);
    }, [location.pathname, navigationType]);

    return null;
};

export default ScrollManager;
